import { useState, useRef, useEffect } from "react";
import NewNavBar from "../../navbar/new_navbar.js";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Form } from "react-bootstrap";
import * as Functions from "../../../functions/functions";
import axios from "../../../context/axios_instance";
import "react-datepicker/dist/react-datepicker.css";
import * as alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import Select from "react-select";
import Footer from "../../footer/footer.js";
import AddressModal from "../../popups/address_modal.js";
const account = {
  firstName: "",
  lastName: "",
  fullName: "",
  email: "",
  encryptedEmail: "",
  unencryptedEmail: "",
  encryptedFirstName: "",
  encryptedLastName: "",
  phoneNumber: "",
  gender: "",
  doctors: [],
  birthday: "",
  cPRNummer: "",
  citizenship: "",
  googleAddress: "",
  patientId: "",
  isEmailConfirmed: "",
};
let countries = [];
function PatientProfile() {
  const intl = useIntl();
  const [address, setAddress] = useState("");
  const [citizenship, setCitizenship] = useState([]);
  const [isDanish, setIsDanish] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [decryptedCPR, setDecryptedCPR] = useState(null);
  const streetRef = useRef(null);
  const zipcodeRef = useRef(null);
  const cityRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedCitizenship, setSelectedCitizenship] = useState([]);
  alertify.set("notifier", "position", "top-right");
  useEffect(() => {
    axios.get("Patient/Account/GetPatientProfile").then((result) => {
      account.doctors = result.data.doctors;
      console.log(account.doctors);
      account.isEmailConfirmed = result.data.isEmailConfirmed;
      account.patientId = result.data.patientId;
      if (result.data.googleAddress !== null) {
        setAddress(Functions.decryptString(result.data.googleAddress));
      }
      setCitizenship(result.data.countryList);
      var citizenshipList = "";
      if (result.data.citizenship !== null) {
        citizenshipList = Functions.decryptString(result.data.citizenship);
        if (citizenshipList.includes("63")) {
          setIsDanish(true);
        }
        var citizenshipArray = citizenshipList.split(",");
        var oldSelectedCitizenship = [];
        citizenshipArray.forEach((element) => {
          oldSelectedCitizenship.push(
            result.data.countryList.find((a) => a.value == element)
          );
          countries.push(parseInt(element));
        });
        setSelectedCitizenship(oldSelectedCitizenship);
      }
      document.getElementById("firstNameId").value = Functions.decryptString(
        result.data.firstName
      );
      if (result.data.cprNummer !== null) {
        setDecryptedCPR(Functions.decryptString(result.data.cprNummer));
      }
      document.getElementById("lastNameId").value = Functions.decryptString(
        result.data.lastName
      );
      document.getElementById("emailId").value = Functions.decryptString(
        result.data.email
      );
      if (result.data.phoneNumber !== null) {
        document.getElementById("phoneNumberId").value =
          Functions.decryptString(result.data.phoneNumber);
      }

      var date = Functions.decryptString(result.data.birthday);
      date = Functions.fixDate(date);
      document.getElementById("birthdayId").value = date;
      document.getElementById("Gender").value = result.data.gender;
      setOpenProfile(true);
    });
  }, []);

  useEffect(() => {
    if (isDanish && decryptedCPR !== null) {
      const input = document.getElementById("CPRNummerId");
      if (input) {
        input.value = decryptedCPR;
        fetchDanishSuggestions();
      }
    }
  }, [isDanish, decryptedCPR]);

  const searchCitizenship = (e) => {
    countries = [];
    var counter = 0;
    for (var i = 0; i < e.length; i++) {
      if (e[i].value === 63) {
        setIsDanish(true);
        counter++;
      }
      countries.push(e[i].value);
    }
    if (counter === 0) {
      setIsDanish(false);
      setDecryptedCPR("");
    }
    setAddress("");
    cityRef.current.value = "";
    zipcodeRef.current.value = "";
    streetRef.current.value = "";
    setSelectedCitizenship(e);
  };

  const editProfile = (e) => {
    e.preventDefault();
    document.getElementById("firstNameIdError").innerHTML = "";
    document.getElementById("lastNameIdError").innerHTML = "";
    document.getElementById("emailIdError").innerHTML = "";
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let fName = document.getElementById("firstNameId").value;
    let lName = document.getElementById("lastNameId").value;
    let email = document.getElementById("emailId").value;
    if (fName === "" || fName.length < 3) {
      document.getElementById("firstNameIdError").innerHTML =
        intl.formatMessage({ id: "RequiredField" });
    } else if (lName === "" || lName.length < 3) {
      document.getElementById("lastNameIdError").innerHTML = intl.formatMessage(
        { id: "RequiredField" }
      );
    } else if (email === "") {
      document.getElementById("emailIdError").innerHTML = intl.formatMessage({
        id: "RequiredField",
      });
    } else if (!emailRegex.test(email)) {
      document.getElementById("emailIdError").innerHTML = intl.formatMessage({
        id: "EmailNotValid",
      });
    } else if (!isCPRValid()) {
    } else {
      editForm();
    }
  };

  function isCPRValid() {
    var valid = true;
    if (isDanish) {
      let cpr = document.getElementById("CPRNummerId").value;
      let gender = document.getElementById("Gender").value;
      let bday = document.getElementById("birthdayId").value;
      let response = Functions.validateCPRNumber(cpr, bday, gender, intl);
      if (!response.status) {
        valid = false;
        document.getElementById("CPRNummerIdError").innerHTML =
          response.error +
          " " +
          intl.formatMessage({ id: "CprNotValidContinue" });
      }
    }
    return valid;
  }

  function editForm() {
    account.birthday = Functions.encryptString(
      document.getElementById("birthdayId").value
    );
    account.email = Functions.encryptString(
      document.getElementById("emailId").value
    );
    account.firstName = Functions.encryptString(
      document.getElementById("firstNameId").value
    );
    account.fullName = Functions.encryptString(
      document.getElementById("firstNameId").value +
        " " +
        document.getElementById("lastNameId").value
    );
    account.googleAddress = Functions.encryptString(address);
    account.lastName = Functions.encryptString(
      document.getElementById("lastNameId").value
    );
    account.phoneNumber = Functions.encryptString(
      document.getElementById("phoneNumberId").value
    );
    account.gender = parseInt(document.getElementById("Gender").value);
    var cpr = "";
    if (isDanish) {
      cpr = document.getElementById("CPRNummerId").value;
    }
    account.cPRNummer = Functions.encryptString(cpr);
    var citizenship = "";
    if (countries.length !== 0) {
      countries.forEach((element) => {
        citizenship += element.toString() + ",";
      });
      citizenship = citizenship.substring(0, citizenship.length - 1);
    }
    account.citizenship = Functions.encryptString(citizenship);
    account.unencryptedEmail = document.getElementById("emailId").value;
    account.encryptedEmail = Functions.encryptStringWithoutTags(
      document.getElementById("emailId").value
    );
    account.encryptedFirstName = Functions.encryptStringWithoutTags(
      document.getElementById("firstNameId").value
    );
    account.encryptedLastName = Functions.encryptStringWithoutTags(
      document.getElementById("lastNameId").value
    );
    account.doctors.forEach((docPatLink) => {
      docPatLink.firstName = Functions.encryptStringForDoctor(
        document.getElementById("firstNameId").value,
        docPatLink.doctor.user.key.publicKey
      );
      docPatLink.email = Functions.encryptStringForDoctor(
        document.getElementById("emailId").value,
        docPatLink.doctor.user.key.publicKey
      );
      docPatLink.lastName = Functions.encryptStringForDoctor(
        document.getElementById("lastNameId").value,
        docPatLink.doctor.user.key.publicKey
      );
      docPatLink.phoneNumber = Functions.encryptStringForDoctor(
        document.getElementById("phoneNumberId").value,
        docPatLink.doctor.user.key.publicKey
      );
      docPatLink.cPRNummer = Functions.encryptStringForDoctor(
        cpr,
        docPatLink.doctor.user.key.publicKey
      );
      docPatLink.citizenship = Functions.encryptStringForDoctor(
        citizenship,
        docPatLink.doctor.user.key.publicKey
      );
    });
    console.log(account);
    axios.post(`Patient/Account/EditPatient`, account).then((result) => {
      console.log(result.data);
      alertify.success(intl.formatMessage({ id: "ProfileSaved" }));
    });
  }

  function fixCPRFormat() {
    let cpr = document.getElementById("CPRNummerId").value;
    if (cpr.length === 10 && !cpr.includes("-")) {
      document.getElementById("CPRNummerId").value =
        cpr.substr(0, 6) + "-" + cpr.substr(6, 4);
    }
  }

  const handlePlaceSelected = (place) => {
    if (isDanish) {
      cityRef.current.value = place.data?.postnrnavn;
      zipcodeRef.current.value = place.data?.postnr;
      streetRef.current.value = place.data?.vejnavn + " " + place.data?.husnr;
    }
  };

  const fetchDanishSuggestions = async () => {
    try {
      const data = await Functions.fetchDanishSuggestions(address);
      if (data.length !== 0) {
        var place = data[0];
        cityRef.current.value = place.data?.postnrnavn;
        zipcodeRef.current.value = place.data?.postnr;
        streetRef.current.value = place.data?.vejnavn + " " + place.data?.husnr;
      }
      return data;
    } catch (err) {
      console.error("Fetch error:", err);
      return [];
    }
  };

  const getAddressDetails = async (addressString) => {
    var data = await Functions.getAddressDetails(addressString);
    if (data !== null) {
      const components = data.results[0].address_components;
      return parseAddressComponents(components);
    } else {
      return null;
    }
  };

  const parseAddressComponents = (components) => {
    const get = (type) =>
      components.find((c) => c.types.includes(type))?.long_name || "";

    return {
      streetNumber: get("street_number"),
      streetName: get("route"),
      city:
        get("locality") ||
        get("postal_town") ||
        get("administrative_area_level_2"),
      postalCode: get("postal_code"),
      country: get("country"),
    };
  };

  useEffect(() => {
    if (isDanish) {
      fetchDanishSuggestions();
    } else {
      fetchGoogleAddress();
    }
  }, [openProfile]);

  const fetchGoogleAddress = async () => {
    if (address !== "") {
      var details = await getAddressDetails(address);
      cityRef.current.value = details.city;
      zipcodeRef.current.value = details.postalCode;
      streetRef.current.value = details.streetName;
    }
  };

  const saveAddress = async () => {
    if (!isDanish) {
      await fetchGoogleAddress();
    }
    editForm();
    setShowModal(false);
  };
  return (
    <div>
      <NewNavBar />
      <div className="pageD container">
        <div className="coverD">
          <h4>
            <FormattedMessage id="Profile" />
          </h4>
          <Form className="register-form-style" onSubmit={editProfile}>
            <h6 className="row-80">
              <FormattedMessage id="PersonalInformation" />
            </h6>
            <h6 className="row-80">
              <FormattedMessage id="FirstName" />
            </h6>
            <Form.Group>
              <Form.Control
                type="text"
                name="firstName"
                id="firstNameId"
                autoComplete="off"
                className="row-Register-without-margins"
                placeholder={Functions.useFormatMessage("FirstName")}
              ></Form.Control>
              <div className="alt-remember-register">
                <span id="firstNameIdError"></span>
              </div>
            </Form.Group>

            <h6 className="row-80">
              <FormattedMessage id="LastName" />
            </h6>
            <Form.Group>
              <Form.Control
                type="text"
                name="lastName"
                id="lastNameId"
                autoComplete="off"
                className="row-Register-without-margins"
                placeholder={Functions.useFormatMessage("LastName")}
              ></Form.Control>
              <div className="alt-remember-register">
                <span id="lastNameIdError"></span>
              </div>
            </Form.Group>

            <h6 className="row-80">
              <FormattedMessage id="Email" />
            </h6>
            <Form.Group>
              <Form.Control
                type="text"
                name="email"
                autoComplete="off"
                id="emailId"
                className="row-Register-without-margins"
                placeholder={Functions.useFormatMessage("Email")}
              ></Form.Control>
              <div className="alt-remember-register">
                <span id="emailIdError"></span>
              </div>
            </Form.Group>

            <h6 className="row-80">
              <FormattedMessage id="PhoneNumber" />
            </h6>
            <Form.Group>
              <Form.Control
                type="text"
                name="phoneNumber"
                id="phoneNumberId"
                autoComplete="off"
                className="row-Register"
                placeholder={Functions.useFormatMessage("PhoneNumber")}
              ></Form.Control>
            </Form.Group>

            <Form.Group style={{ marginBottom: "15px" }}>
              <h6 className="row-80-h6">
                <FormattedMessage id="Citizenship" />
              </h6>
              <Select
                className="row-80-h6"
                id="CitizenshipId"
                options={citizenship}
                isMulti
                placeholder={<FormattedMessage id="SelectCitizenship" />}
                value={selectedCitizenship}
                onChange={searchCitizenship}
              />
            </Form.Group>

            {isDanish && (
              <Form.Group>
                <h6 className="row-80-h6">
                  <FormattedMessage id="CPRNummer" />
                </h6>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  id="CPRNummerId"
                  className="row-Register"
                  onChange={fixCPRFormat}
                ></Form.Control>
                <div className="alt-remember-register">
                  <span id="CPRNummerIdError"></span>
                </div>
              </Form.Group>
            )}

            <h6 className="row-80">
              <FormattedMessage id="Gender" />
            </h6>
            <Form.Select className="row-Register" id="Gender">
              <option value="0">
                <FormattedMessage id="Male" />
              </option>
              <option value="1">
                <FormattedMessage id="Female" />
              </option>
            </Form.Select>

            <Form.Group>
              <h6 className="row-80">
                <FormattedMessage id="Birthday" />
              </h6>
              <Form.Control
                type="text"
                disabled="disabled"
                name="birthday"
                id="birthdayId"
                autoComplete="off"
                className="row-Register"
                placeholder={Functions.useFormatMessage("Birthday")}
              ></Form.Control>
            </Form.Group>

            <h6 className="row-80">
              <FormattedMessage id="Address" />
            </h6>

            <Form.Group>
              <h6 className="row-80">
                <FormattedMessage id="Street1" />
              </h6>
              <Form.Control
                type="text"
                disabled="disabled"
                name="Street1"
                ref={streetRef}
                autoComplete="off"
                className="row-Register"
              ></Form.Control>
            </Form.Group>

            <Form.Group>
              <h6 className="row-80">
                <FormattedMessage id="ZipCode" />
              </h6>
              <Form.Control
                type="text"
                disabled="disabled"
                name="ZipCode"
                ref={zipcodeRef}
                autoComplete="off"
                className="row-Register"
              ></Form.Control>
            </Form.Group>

            <Form.Group>
              <h6 className="row-80">
                <FormattedMessage id="City" />
              </h6>
              <Form.Control
                type="text"
                disabled="disabled"
                name="City"
                ref={cityRef}
                autoComplete="off"
                className="row-Register"
              ></Form.Control>
            </Form.Group>

            <Form.Group>
              {/* {!isDanish && <LoadScript
                          googleMapsApiKey={config.url.GOOGLE_API_KEY}
                          libraries={["places"]}
                        >
                          <GoogleAutoComplete
                              onPlaceSelected={handlePlaceSelected}
                              inputValue={address}
                              disabled={true}
                              setInputValue={setAddress}
                            />
                      </LoadScript>}
                      {isDanish && <DanishAutoComplete
                          onPlaceSelected={handlePlaceSelected}
                          inputValue={address}
                          setInputValue={setAddress}
                          disabled={true}
                        />} */}
            </Form.Group>
            <div
              className="btn btn-dark-blue row-80"
              id="editAddress"
              onClick={() => setShowModal(true)}
            >
              <FormattedMessage id="EditAddress" />{" "}
            </div>
            <Button
              type="submit"
              className="btn btn-dark-blue row-80"
              value="Edit"
            >
              <FormattedMessage id="Save" />
            </Button>
          </Form>
        </div>
        <div className="coverD">
          <div style={{ textAlign: "-webkit-center" }}>
            <Footer />
          </div>
        </div>
        <AddressModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          onPlaceSelected={handlePlaceSelected}
          address={address}
          setAddress={setAddress}
          saveAddress={saveAddress}
          isDanish={isDanish}
        />
      </div>
    </div>
  );
}

export default PatientProfile;
